sn-how-it-works {
  display: block;
  margin-bottom: 32px;

  .column {
    display: block;
  }

  .section-side-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.33;
    margin: 0 0 24px;
    color: #1a1a1a;
  }

  .how-it-works {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .how-it-works__item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .how-it-works__icon {
    flex-shrink: 0;
    width: 64px;
    height: 64px;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .how-it-works__details {
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    padding-top: 4px;

    @include desktop {
      font-size: 20px;
      line-height: 28px;
    }

    strong {
      font-weight: 700;
      color: #1a1a1a;
    }

    .line-break {
      display: block;
    }
  }
}
